// src/contexts/SeasonContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import { getCurrentSeason } from '../utils/seasonUtils';

const SeasonContext = createContext();

const SEASON_KEY = 'selectedSeason';
const OVERRIDE_KEY = 'seasonIsManualOverride';

export function SeasonProvider({ children }) {
    const [selectedSeason, setSelectedSeasonState] = useState(() => {
        // Only honor a saved season if the user deliberately picked a
        // *different* (historical) season - otherwise always default to
        // the current season, so the site rolls forward on its own each
        // year instead of getting stuck on whatever was current when the
        // visitor last saved a value to localStorage.
        const isOverride = localStorage.getItem(OVERRIDE_KEY) === 'true';
        const saved = localStorage.getItem(SEASON_KEY);
        return (isOverride && saved) ? saved : getCurrentSeason();
    });

    const setSelectedSeason = (season) => {
        const isCurrent = season === getCurrentSeason();
        localStorage.setItem(OVERRIDE_KEY, isCurrent ? 'false' : 'true');
        setSelectedSeasonState(season);
    };

    useEffect(() => {
        // Save to localStorage whenever it changes
        localStorage.setItem(SEASON_KEY, selectedSeason);
    }, [selectedSeason]);

    return (
        <SeasonContext.Provider value={{ selectedSeason, setSelectedSeason }}>
            {children}
        </SeasonContext.Provider>
    );
}

export function useSeason() {
    const context = useContext(SeasonContext);
    if (!context) {
        throw new Error('useSeason must be used within a SeasonProvider');
    }
    return context;
}
